import { render } from "./LbrxAssistPopup.vue?vue&type=template&id=5597c368&scoped=true"
import script from "./LbrxAssistPopup.vue?vue&type=script&lang=js"
export * from "./LbrxAssistPopup.vue?vue&type=script&lang=js"

import "./LbrxAssistPopup.vue?vue&type=style&index=0&id=5597c368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5597c368"]])

export default __exports__